import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CreNgModule, SpinnerModule } from 'cre-ng';

import { FleetCompetitionResultsModule } from '@app/fleet-competition-results';
import { SharedModule } from '@app/shared';
import { SportTeamBannerModule } from '@app/sport-team-banner';
import { SportTeamLogoModule } from '@app/sport-team-logo';
import { DriverTeamInformationComponent } from './driver-team-information.component';

@NgModule({
  declarations: [DriverTeamInformationComponent],
  exports: [DriverTeamInformationComponent],
  imports: [
    CommonModule,
    CreNgModule,
    FleetCompetitionResultsModule,
    SharedModule,
    SportTeamBannerModule,
    SportTeamLogoModule,
    SpinnerModule,
  ],
  providers: [],
})
export class DriverTeamInformationModule {
  constructor() {}
}
